import {Component, ElementRef, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Config} from '../config';
import { MapService } from '../map-view/map.service';
import { EventsService } from '../EventsService';
import { EsriTasksService } from '../esriTasks/esriTasks-service';
import TileLayer = require('esri/layers/TileLayer');

@Component({
    selector: 'basemapNav-component',
    template: require('../tools/basemapNav.component.html'),
    styles: [require('../tools/basemapNav.component.css')]
})
export class BasemapNavComponent {
    appSettings:Object = null;

    arrowIcon:string = "arrow_drop_up";
    selectYearTitle:string = "Select aerial year";
    showOrthoList:boolean = false;
    mapSliderControl = new FormControl();
    initTransparencyValue: number = 0;

    currentStatePlane:Object;

    statePlaneLayers:Array<Object> = [];

    IEbrowser:boolean = false;
    internetExplorer:boolean = false;

    constructor(private elRef:ElementRef, private _mapService:MapService, private _eventsService:EventsService, private _esriTasksService:EsriTasksService){
        if(this.appSettings == null){
            this.appSettings = Config.config[0];
        }
    }

    ngOnInit(){
        this.statePlaneLayers = this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["layers"];
        this.statePlaneLayers.forEach(l => {
            if(l["id"] == this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["default"]){
                l["selected"] = true;
                this.currentStatePlane = l;
            }else{
                l["selected"] = false;
            }
        });
        this.currentStatePlane["opacity"] = this.appSettings["Map"]["Layers"]["StatePlaneLayers"]["startOpacity"];

        //Check if MSIE or Edge browser
        try {
            if(navigator.userAgent.indexOf("MSIE ") != -1 || navigator.userAgent.indexOf("Trident/") != -1 || navigator.userAgent.indexOf("Edge/") != -1)
            {
                this.IEbrowser = true;
            }
            if(navigator.userAgent.indexOf("MSIE ") != -1 || navigator.userAgent.indexOf("Trident/") != -1){
                this.internetExplorer = true;
            }
        } catch (error) {
            console.log("Could not find browser type");
        }
    }

    ngAfterViewInit(){
        this.mapSliderControl.valueChanges
            .subscribe(n => this.sliderChange(n));
    }

    //function to run on slider change for toggleing aerial transparency 
    sliderChange(slidervalue:number) {
        let opacityValue:number = slidervalue;
        this._mapService.view.map.findLayerById(this.currentStatePlane["id"]).opacity = opacityValue / 100;
        this.currentStatePlane["opacity"] = opacityValue/100;
    }

    basemapToggle(slidervalue:number){
        this.initTransparencyValue = slidervalue;
    }

    selectOrthoYear(event:any){
         (this.arrowIcon == "arrow_drop_up") ? this.showOrthoYearOptions() : this.hideOrthoYearOptions();
    }

    showOrthoYearOptions(){
        this.arrowIcon = "arrow_drop_down";
        this.showOrthoList = true;
        this.selectYearTitle = "Hide";
    }

    hideOrthoYearOptions(){
        this.arrowIcon = "arrow_drop_up";
        this.showOrthoList = false;
        this.selectYearTitle = "Select aerial year";
    }

    layerSelected(layerObject:Object){
        if(this.currentStatePlane["id"] == layerObject["id"]){
            this.hideOrthoYearOptions();
            return;
        }

        this._mapService.view.map.findLayerById(this.currentStatePlane["id"]).visible = false;

        layerObject["opacity"] = this.currentStatePlane["opacity"];
        if(!this._mapService.view.map.findLayerById(layerObject["id"])){
            var tl:TileLayer = new TileLayer({
                id:layerObject["id"],
                url:layerObject["url"],
                "opacity": layerObject["opacity"]
            });
            this._mapService.view.map.add(tl, 1);
        }else{
            for (var l of this.statePlaneLayers){
                if(l["id"] == layerObject["id"]){
                    this._mapService.view.map.findLayerById(l["id"]).visible = true;
                // }//else{
                //     this._mapService.view.map.findLayerById(l["id"]).visible = false;
                // }
                    break;
                }
            }
        }
        for (var l of this.statePlaneLayers){
            if(l["id"] == layerObject["id"]){
                l["selected"] = true;
            }else{
                l["selected"] = false;
            }
        }
        this.currentStatePlane = layerObject;
        this.hideOrthoYearOptions();
    }

    inputChange(event){
        if(this.internetExplorer){
            this.initTransparencyValue = event.currentTarget.value;
            this.sliderChange(event.currentTarget.value);
        }
    }
}



// WEBPACK FOOTER //
// ./app/tools/basemapNav.component.ts